var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6",
      "sm": "6",
      "xs": "6"
    }
  }, [_c('image-upload-button', {
    attrs: {
      "isUploaded": _vm.isUploaded,
      "isLoading": _vm.isLoading,
      "text": _vm.text,
      "textAlt": _vm.textAlt
    },
    on: {
      "uploaded": _vm.uploaded
    }
  })], 1), !_vm.hasFile ? _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6",
      "sm": "6",
      "xs": "6"
    }
  }, [_c('file-example', {
    attrs: {
      "example": _vm.example
    }
  })], 1) : _vm._l(_vm.files, function (item, i) {
    return _c('v-col', {
      key: i,
      attrs: {
        "cols": "6",
        "md": "6",
        "sm": "6",
        "xs": "6"
      }
    }, [_c('file-upload', {
      attrs: {
        "item": item
      },
      on: {
        "deleted": _vm.deleted
      }
    })], 1);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }